/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSelectionCheckedEmpty: {
  name: 'selection-checked-empty';
  data: string;
} = {
  name: 'selection-checked-empty',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm16 0H5v14h14V5Z" fill="currentColor"/></svg>`,
};
